export default (app) => {
  app.database.on("initMemory", ({ collection, db, inited }) => {
    if (inited) return;
    db.get = (query) => (query.data ? query : { ...query, data: db.dbIndex[query.id] });
    collection.on("get", 1000, db.get);
  });
};
